import React from "react";
import MarkdownIt from "markdown-it";
import parse from 'html-react-parser';
import anchor from "markdown-it-anchor";
import commandDoc from "../assets/command_doc.md";

export class LearnPage extends React.Component{
    constructor(){
        super();
        this.state = {
            commandDoc:"Loading..."
        }
    }
    componentDidMount(){
        window.scrollTo(0, 0);
        fetch(commandDoc)
        .then((r) => r.text())
        .then(text  => {
            const md=MarkdownIt({html:true});
            md.use(anchor, {
                permalink: anchor.permalink.headerLink()
            })
            const res = md.render(text);
            this.setState((prevState)=>{
                return {
                    ...prevState,
                    commandDoc:res
                }
            })
        })
    }
    render(){
        return (
            <div className="learn-page-container">
                {/* <h1>Learn Page</h1> */}
                <div className="markdown-body-container">
                    <div className="markdown-container">
                        {parse(this.state.commandDoc)}     
                    </div>
                </div>
            </div>
        )
    }
}